let appMode = process.env.REACT_APP_ENV;
let ASSET_URL = "http://103.189.173.7:2502/";
let URL;
let socketUrl;
let WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL;

console.log("appMode", appMode);

// 3.20.147.34 

if (appMode === "development") {
  URL = "http://localhost:2502/api";
} else {
  URL = "http://103.189.173.7:2502/api";
}

// For auth-only project we keep only authentication-related endpoints
let apiPath = {
  baseURL: URL,
  socketUrl,
  assetURL: ASSET_URL,
  WEBSITE_URL,

  // Admin auth APIs
  login: "/login",
  adminLogin: "/login",
  hotelLogin: "/hotel_partnerLogin",
  agentLogin: "/agent_login",
  logout: "/logout",
  profile: "/getsuperAdmin",
  getSuperAdmin: "/getsuperAdmin",
  updateProfile: "/updateProfile",
  updateSuperAdminDetails: "/updateSuperAdmin_details",
  superAdminChangePassword: "/superAdmin_change_password",
  changePassword: "/change-password",
  forgotPassword: "/forgot-password",
  verifyOTP: "/verify-otp",
  resetPassword: "/reset-password",
  adminForgotPassword: "/admin/forgot-password",
  adminResetPassword: "/admin/reset-password",

  // Session status (used by AuthContext)
  checkSessionStatus: "admin/session/check-status",

  // Hotel meals management APIs
  getMeals: "/getMeals",
  addMeal: "/addMeal",
  updateMeal: "/updateMeal",
  deleteMeal: "/deleteMeal",

  // Hotel management APIs
  hotels: "/getAllHotels",
  getHotelById: "/getHotel",
  createHotel: "/create_Hotel",
  dashboardAllCount: "/Dashboard_all_count",
  updateHotel: "/updateHotel",
  getRoomInventory: "/getRoomInventory",
  updateRoom: "/updateRoom",
  addRooms: "/addRooms",
  deleteRoom: "/deleteRoom",

  // Agent search & booking APIs
  agentSearch: "agent/search",
  agentSeatLocks: "agent/seat-locks",
  agentBookings: "agent/bookings",
  getAgentHotelsDetails: "/get_agent_hotels_details",

  // Agent-specific function-based endpoints (Dynamic URLs)
  agentChangePassword: (id) => `${URL}/agent_change_password/${id}`,
  agentUpdateProfile: (id) => `${URL}/update_agent_profile/${id}`,
  agentDashboardCounts: (id) => `${URL}/get_dashboard_counts/${id}`,
  agentHotelsDetails: (id) => `${URL}/get_agent_hotels_details/${id}`,
  agentBookingsByAgent: (id) => `${URL}/get_bookings_by_agent/${id}`,
  agentRecentBookings: (id) => `${URL}/get_recent_bookings_by_agent/${id}`,
  getAgentFloorsWiseRooms: (hotelId) => `${URL}/getAll_floors_wise_Rooms_of_Hotel/${hotelId}`,
  assignRoomToBooking: (bookingId) => `${URL}/assingRoom_to_booking/${bookingId}`,

  // Agent status toggle (manager only)
  toggleAgentStatus: (hotelId, agentId) => `${URL}/manager/toggle_agent_status/${hotelId}/${agentId}`,

  // Unified Notification APIs
  notifications: "/notifications",
  notificationsAll: "/notifications/all",
  markNotificationRead: (id) => `/notifications/${id}/read`,
  markAllNotificationsRead: "/notifications/mark-all-read",
  sendNotificationToCustomer: "/notifications/send/customer",
  sendNotificationToAllAgents: "/notifications/send/all-agents",
  sendNotificationToAllHotels: "/notifications/send/all-hotels",
  createNotification: "/notifications/create",
  createBookingWithGuest: "/create_booking_with_guest",
  getAllGuests: "/guest/all",
  createGuest: "/guest/create",
  getAirlines: "/guest/airlines",
  rejectBooking: (id) => `${URL}/reject_booking/${id}`,
  resendBookingSMS: (id) => `${URL}/bookings/${id}/resend-sms`,
  airlineDashboardStats: "/airline/dashboard-stats",
  qrSetPassword: "/qr/set-password",
  qrResendEmail: "/qr/resend-email",
  qrValidate: "/qr/validate",
  // Bus Company APIs
  busDashboard: "/bus/dashboard",
  busPassengers: "/bus/passengers",
  busDailyReport: "/bus/daily-report",
  busExport: "/bus/export",
  createBusCompany: "/admin/create-bus-company",
  updateBusStatus: (id) => `/admin/update-bus-status/${id}`,
  airlineHotels: "/airline/hotels",
};


export const getImageUrl = (imagePath) => {
  if (!imagePath) return "";
  if (typeof imagePath !== "string") return "";
  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) return imagePath;
  return `${ASSET_URL}${imagePath}`.replace(/([^:]\/)\/+/g, "$1");
};

export default apiPath;
